import { NgModule } from "@angular/core";
import { GestureEventsDirective } from "./gestureEvents.directive";
import { HideOnscrollDirective } from "./hideOnscroll.directive";
import { HorizontalSwipeEventDirective } from "./horizontalSwipeEvents.directive";

@NgModule({
    declarations: [
        GestureEventsDirective,
        HorizontalSwipeEventDirective,
        HideOnscrollDirective,
    ],
    imports: [],
    exports: [
        GestureEventsDirective,
        HorizontalSwipeEventDirective,
        HideOnscrollDirective,
    ],
    providers: [],
})
export class DirectivesModule {
}
